<template>
  <PlanSummaryCardText
    :showCouponBadge="hasAppliedCoupon"
    :title="planSummaryTitle"
    :pricing="planPricing"
    subheading="We'll remind you three days before your trial ends. Cancel anytime."
    :trialInfo="trialDisplay"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { useCouponStore } from '@/store/CouponStore'
import { usePlanStore } from '@/store/PlanStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
const checkoutStore = useCheckoutStore()
const planStore = usePlanStore()
const priceStore = usePriceStore()
const productStore = useProductStore()
const couponStore = useCouponStore()

const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice } = storeToRefs(priceStore)
const { selectedPlanIntervalAsNoun } = storeToRefs(planStore)
const { hasAppliedCoupon, appliedCouponTrialLength } = storeToRefs(couponStore)

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)

const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value}`)

const trialDisplay = computed(() => `after a ${appliedCouponTrialLength.value} trial.`)
</script>
